import { breakpoints } from '@awazevr/design-system.utils.react'
import Head from 'next/head'
import { LCPCandidate, Picture } from '@/components/content/contentMapper'
import { FC } from 'react'

function addQueryParams(url: string) {
  try {
    // fix url for images that start with //images.ctfassets.net
    if (!url?.startsWith('http')) {
      url =
        process.env.NODE_ENV === 'development' ? `http:${url}` : `https:${url}`
    }
    const urlObj = new URL(url)
    const params = { q: '80', fm: 'webp' }
    for (const key in params) {
      if (!urlObj.searchParams.has(key)) {
        urlObj.searchParams.append(key, params[key])
      }
    }

    return urlObj.toString()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    // we ignore the error and return the original url
    return url
  }
}

export const LcpImagePreload: FC<{ lcpImage?: Picture | string }> = ({
  lcpImage,
}) => {
  if (!lcpImage) {
    return <></>
  }
  if (typeof lcpImage === 'string') {
    return (
      <Head>
        <link rel="preload" href={lcpImage} as="image" />
      </Head>
    )
  }

  return (
    <Head>
      {lcpImage.mobileImage && (
        <link
          rel="preload"
          href={addQueryParams(lcpImage.mobileImage)}
          as="image"
          media={`(max-width: ${breakpoints[0]}px)`}
        />
      )}
      {lcpImage.tabletImage && (
        <link
          rel="preload"
          href={addQueryParams(lcpImage.tabletImage)}
          as="image"
          media={`(min-width: ${breakpoints[0]}.1px) and (max-width: ${breakpoints[1]}px)`}
        />
      )}
      {lcpImage.image && (
        <link
          rel="preload"
          href={addQueryParams(lcpImage.image)}
          as="image"
          media={`(min-width: ${breakpoints[1]}.1px)`}
        />
      )}
    </Head>
  )
}

export const getLcpCandidate = (
  images: LCPCandidate[],
): Picture | string | null => {
  const [candidate] = images
  if (!candidate) {
    return null
  }
  if ('src' in candidate) {
    return candidate.src
  }
  const { image, tabletImage, mobileImage } = candidate as Picture
  return { image, tabletImage, mobileImage }
}
